// Declared twice so that docs appear when selecting colors
export interface RadarPalette extends Record<string, string> {
  /** **#FAE0E1** Radar */
  readonly radar10: string;
  /** **#FFD2D2** Radar */
  readonly radar30: string;
  /** **#FB9493** Radar */
  readonly radar60: string;
  /** **#E45853** Radar */
  readonly radarPrimary: string;
  /** **#D7303B** Radar */
  readonly radar80: string;
  /** **#B51F1A** Radar */
  readonly radar90: string;
}

export const radarPalette: RadarPalette = {
  radar10: '#FAE0E1',
  radar30: '#FFD2D2',
  radar60: '#FB9493',
  radarPrimary: '#E45853',
  radar80: '#D7303B',
  radar90: '#B51F1A',
};
